module.exports = __webpack_public_path__ + "img/MR.4a9f1719.png";